import React from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { useLocation, useNavigate } from 'react-router-dom';
import { hideHeadband } from 'action-creators/headband';
import { setMetricsEvent } from 'action-creators/metrics';
import withApa from 'newComponents/WithApa/WithApa';
import { useSelector, useDispatch } from 'react-redux';
import { selectHeadbandState } from 'selectors/headband';
import { METRICS as m, TO_PAY_WAY, TO_COMPLETE_INFO } from './constants';
import closeIcon from './close_icon.png';
import './Headband.scss';
import { useVerifyIsMobile } from 'hooks/useVerifyIsMobile';

export const HeadBand = ({ translations }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const {
    home_ticker_iptelmex_label, // register iptelmex
    home_ticker_mail_label, // register with email
  } = translations;
  let inCompleteInfoPage = false;

  if (location.pathname.includes('completeinfo')) {
    inCompleteInfoPage = true;
  }
  const dispatch = useDispatch();
  const { isVisible, message, headbandAction } = useSelector(
    selectHeadbandState,
  );
  const { displayModal: isProfileManagerShowing } = useSelector(
    state => state.profilesManager,
  );
  const showMenuMobile = useSelector(state => state.menuAvatar.showMenuMobile);
  const { isMobile } = useVerifyIsMobile(918);

  const sendMetrics = params => {
    dispatch(
      setMetricsEvent({
        tagManager: {
          ...params,
        },
      }),
    );
    dispatch(
      setMetricsEvent({
        type: m.EXECUTOR,
        success: true,
      }),
    );
  };

  const handleClose = () => {
    let eventLabel = '';
    if (message === TO_PAY_WAY) eventLabel = m.LABEL.CLOSE_PAYMENT;
    if (message === TO_COMPLETE_INFO) eventLabel = m.LABEL.CLOSE_TELMEX;

    sendMetrics({
      event: m.EVENT,
      eventCategory: m.CATEGORY.HOME,
      eventAction: m.ACTION.TICKER,
      eventLabel,
    });
    dispatch(hideHeadband());
  };

  const handleClickAction = () => {
    if (headbandAction) {
      let eventLabel = '';

      if (message === TO_PAY_WAY) eventLabel = m.LABEL.OPEN_PAYMENT;
      if (message === TO_COMPLETE_INFO) eventLabel = m.LABEL.OPEN_TELMEX;

      sendMetrics({
        event: m.EVENT,
        eventCategory: m.CATEGORY.HOME,
        eventAction: m.ACTION.TICKER,
        eventLabel,
      });
      headbandAction(navigate);
    }
    dispatch(hideHeadband());
  };

  let textMessage;
  if (message === TO_PAY_WAY) {
    textMessage = home_ticker_mail_label;
  }
  if (message === TO_COMPLETE_INFO) {
    textMessage = home_ticker_iptelmex_label;
  }

  if (
    !isVisible ||
    inCompleteInfoPage ||
    isProfileManagerShowing ||
    (showMenuMobile && isMobile)
  )
    return null;
  return (
    <>
      <section
        id="headband"
        className={`Headband fixed ${isVisible ? 'visible' : 'hidden'}`}
      >
        <div />
        <button type="button" onClick={handleClickAction}>
          <h2> {textMessage}</h2>
          <h4> {textMessage}</h4>
        </button>
        <button
          type="button"
          onClick={handleClose}
          className="Headband__button"
        >
          <img src={closeIcon} alt="close_icon" />
        </button>
      </section>
      <div
        id="headband"
        className={`Headband sticky ${isVisible ? 'visible' : 'hidden'}`}
      >
        <button type="button">
          <h2> {textMessage}</h2>
          <h4> {textMessage}</h4>
        </button>
        <button
          type="button"
          onClick={handleClose}
          className="Headband__button"
        >
          X
        </button>
      </div>
    </>
  );
};

HeadBand.propTypes = {
  translations: PropTypes.shape({
    home_ticker_iptelmex_label: PropTypes.string,
    home_ticker_mail_label: PropTypes.string,
  }),
};

export default compose(withApa)(HeadBand);
